import { useEffect, useState } from "react";
import MenuContext from "./menu.context";
import { MenuContentOptions, MenuContextType } from "./Menu.types";

export const MenuProvider = ({ children }) => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const [menuBg, setMenuBg] = useState<string>("#8f0318");
  const [menuContent, setMenuContent] = useState<MenuContentOptions>(
    MenuContentOptions.NAVIGATION
  );

  useEffect(() => {
    if (!isMenuOpen) {
      setMenuContent(MenuContentOptions.NAVIGATION);
    }
  }, [isMenuOpen]);

  useEffect(() => {
    switch (menuContent) {
      case MenuContentOptions.NAVIGATION:
        return setMenuBg("#8f0318");
      case MenuContentOptions.TRAILER:
      case MenuContentOptions.SYNOPSIS:
      case MenuContentOptions.CAST_CREW:
        return setMenuBg("black");
      default:
        break;
    }
  }, [menuContent]);

  const value: MenuContextType = {
    isMenuOpen,
    setIsMenuOpen,
    menuBg,
    setMenuBg,
    menuContent,
    setMenuContent,
  };

  return <MenuContext.Provider value={value}>{children}</MenuContext.Provider>;
};
